module.exports = __webpack_public_path__ + "img/sea-doo.86b2ad8f.png";